/**
 * Returns an object from a query params strings
 * @param {string} queryParamsString - query params to be converted into an object.
 * Example: "?error=server_error&error_description=unexpected_error_occurred"
 * To: {error: 'server_error', error_description: 'unexpected_error_occurred' }
 */
const queryParamsToObject = (queryParamsString) => {
    let searchParams = queryParamsString;
    if (queryParamsString.includes('?')) {
        searchParams = searchParams.substring(1);
    }
    const result = {};
    searchParams.split('&').forEach(param => {
        const [key, value] = param.split('=');
        result[key] = value;
    });
    return result;
};
export default queryParamsToObject;
